import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Card from 'react-bootstrap/Card';
import { CardBody } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Skeleton } from '@mui/material';
import { skeleton_animation_style_primary } from '../../../../constants/constants';
import { removeHTMLElementsAndTruncateText } from '../../basic-component/CommonUtils';
const ContactInfo = (data) => {

  const { t } = useTranslation();
  const data1 = data.data;
  console.log(data);
  console.log(data.data);
  console.log(data.latestInfo);

  // console.log(data.data.feedbackDetails?.user?.email);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [emailId, setEmailId] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [feedbackGivenBy, setFeedbackGivenBy] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");
  const [dateOfFeedback, setDateOfFeedback] = useState("");
  const generateAppropriateDate = (value) => {
    if (value === undefined || value === null) {
      return "N/A";
    } else {
      const date = new Date(value);
      const formattedDate = date.toLocaleString('en-GB', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
      });

      return formattedDate;
    }
  };
  const generateAppropriateDateComplaint = (value) => {
    if (value === undefined || value === null) {
      return 'N/A';
    } else {
      const date = new Date(value);
      const formattedDate =
        (date.getDate() >= 10 ? date.getDate() : '0' + date.getDate()) +
        '-' +
        (date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : '0' + (date.getMonth() + 1)) +
        '-' +
        date.getFullYear();
        // ' ' +
        // (date.getHours() % 12 || 12) +
        // ':' +
        // (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
        // ' ' +
        // (date.getHours() >= 12 ? 'pm' : 'am');
      return formattedDate;
    }
  };
  useEffect(() => {
    if (data1 && data1.feedbackDetails && data1.feedbackDetails.user) {
      const stringifiedData = data1;
      const createDate = stringifiedData?.feedbackDetails?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      setEmailId(stringifiedData?.feedbackDetails?.user?.email || "");
      setPhoneNumber(stringifiedData?.feedbackDetails?.user?.phone || "");
      setOrganizationName(stringifiedData?.feedbackDetails?.user?.orgName || "");
      setFeedbackGivenBy(stringifiedData.feedbackDetails.user.firstName + ' ' + stringifiedData.feedbackDetails.user.lastName);
      setMobileNumber(stringifiedData?.feedbackDetails?.user?.mobile || "");
      setAddress(stringifiedData?.feedbackDetails?.user?.addressLine || "NA");
      setDateOfFeedback(generateAppropriateDate(parsedDate));
    }
    else if (data1 && data1.feedbackDetails) {
      const createDate = stringifiedData?.feedbackDetails?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      const stringifiedData = data1;
      setEmailId(stringifiedData?.feedbackDetails.emailId || "");
      setOrganizationName(stringifiedData?.feedbackDetails.organizationName || "");
      setDateOfFeedback(generateAppropriateDate(parsedDate));

    }
    else if (data1 && data1.id) {
      const createDate = stringifiedData?.feedbackDetails?.createDate || "";
      const parsedDate = createDate ? new Date(createDate) : "";
      const stringifiedData = data1;
      setEmailId(stringifiedData?.emailId || "");
      setPhoneNumber(stringifiedData?.phoneNo || "");
      setOrganizationName(stringifiedData?.organizationName || "");
      setFeedbackGivenBy(stringifiedData.createFirstName + ' ' + stringifiedData.createLastName);
      setMobileNumber(stringifiedData?.mobileNo || "");
      setAddress(stringifiedData?.user?.addressLine || "NA");
      setDateOfFeedback(generateAppropriateDate(parsedDate));
    }

    console.log(data?.data?.feedbackDetails?.id);
  }, [data]);
  console.log(data?.data?.feedbackDetails?.id);
  console.log(phoneNumber);
  console.log(emailId);
  // useEffect(()=>{
  //   console.log(latestInfo);
  // },[latestInfo])
  function handleClick(item) {
    // Implement your logic here to handle the click event
    console.log('Clicked item:', item);
    if (data.onClick) {
      data.onClick(item.id); // Assuming item has an id property
    }
    // You can perform further actions based on the clicked item
  }

  return (
    <>
      <Card.Title className='mb-3'>{t('general.label.contact.info')}</Card.Title>
      <div className='section contact-info'>
        {organizationName ? (
          <>
            <h6 className='mb-2'>{feedbackGivenBy}</h6>
            {organizationName && (
              <p className='text-secondary lh-normal mb-2 d-flex'><i class="ti ti-building me-1 text-black"></i>{organizationName}</p>
            )}
            {phoneNumber && (
              <p className='text-secondary lh-normal mb-2 d-flex'><i class="ti ti-phone me-1 text-black"></i>{phoneNumber}</p>
            )}
            {mobileNumber && (
              <p className='text-secondary lh-normal mb-2 d-flex'><i class="ti ti-device-mobile me-1 text-black"></i>{mobileNumber}</p>
            )}
            {emailId && (
              <p className='text-secondary lh-normal mb-2 d-flex'><i class="ti ti-mail me-1 text-black"></i>{emailId}</p>
            )}
            {address && (
              <p className='text-secondary lh-normal mb-2 d-flex'><i class="ti ti-map-pin me-1 text-black"></i>{address}</p>
            )}
          </>
        ) : (
          <>
            <Skeleton animation={skeleton_animation_style_primary} variant="rounded" className='mb-1' />

            <Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={100} />
          </>
        )}
      </div>
      <div className='section ongoing-complaint'>
        <h5 className='card-title mb-3'>{t('general.label.ongoing.complaint')}</h5>
        {organizationName ?(
        <>
        {(organizationName && data)?.latestInfo?.map((item, index) => {
          const feedbackDate = generateAppropriateDateComplaint(item.createDate);
          const truncatedDescription = item?.description ? removeHTMLElementsAndTruncateText(item.description, 23) : '';
  
          return (
            <div
              key={index}
              style={{
                color: item.id === data?.data?.feedbackDetails?.id ? 'red' : 'inherit',
                fontWeight: item.id === data?.data?.feedbackDetails?.id ? 'normal' : 'normal'
              }}
              className="text-primary lh-normal mb-2 d-flex cursor-pointer"
              onClick={() => handleClick(item)}
            >
              <i className="ti ti-external-link me-1"></i>
              <span>{feedbackDate} {truncatedDescription}</span>
            </div>
          );
        })}
        </>
):(<>
{/* <Skeleton animation={skeleton_animation_style_primary} variant="rounded" className='mb-1' /> */}

<Skeleton animation={skeleton_animation_style_primary} variant="rounded" height={100} />
</>)}
      </div>
    </>
  );
  
}
export default ContactInfo;